/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Submit_Translation_JobsInputs */



/**
* | output |
* | --- |
* | "Submit {count} Translation Jobs" |
*
* @param {Submit_Translation_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_translation_jobs = /** @type {((inputs: Submit_Translation_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Translation_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Soumettre ${i?.count} traductions`)
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsaufträge einreichen (PH_0__)")
	if (locale === "it") return /** @type {LocalizedString} */ (`Invia ${i?.count} lavori di traduzione`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Отправить ${i?.count} Заказы на перевод`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Enviar ${i?.count} Trabajos de traducción`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`提交 ${i?.count} 翻译工作`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 翻訳案件を送信`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} अनुवाद कार्य जमा करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Enviar trabalhos de tradução ${i?.count}`)
	return /** @type {LocalizedString} */ (`Submit ${i?.count} Translation Jobs`)
});